import { Card } from '@/components/ui/card';

import { CardContent } from '@/components/ui/card';
import { Switch } from '@/components/ui/switch';
import { useCreateEvent } from '@/features/events/hooks/useCreateEvent';
import { EventType } from '@/features/events/types/EventType';
import { cn } from '@/lib/utils';

interface Props {
  onFilterChange: (filter: boolean) => void;
  isFilteringCategory: boolean;
}

export const FilterBar = ({ onFilterChange, isFilteringCategory }: Props) => {
  const { sendEvent } = useCreateEvent()
  const onFilterClick = async () => {
    await sendEvent({
      event: EventType.CLICK,
      sub_category: "ocr_interaction",
      event_metadata: { action: "click_on_filter_paraeters" }
    })
    onFilterChange(!isFilteringCategory)
  }

  return (
    <Card className='bg-background-light border-none shadow-0 min-h-16'>
      <CardContent className='flex items-center justify-between'>
        <div className='flex items-center gap-4'>
          <p>Ordina per: </p>
          <div className='flex items-center gap-2'>
            <div className='flex items-center gap-2'>
              <p>Rischio</p>
              <Switch
                checked={isFilteringCategory}
                onCheckedChange={onFilterClick}
                className={cn(
                  'data-[state=checked]:bg-primary',
                  'data-[state=unchecked]:bg-holifya-red',
                )}
              />
              <p>Categoria</p>
            </div>
          </div>
        </div>
        {
          // TODO-TM: Centralise bg-slate color for icon
        }
        {/* <div className='bg-slate-200 rounded-full p-2'>
          <ListFilter size={16} />
        </div> */}
      </CardContent>
    </Card>
  );
};
